import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  termsData: [],
  error: "",
  success: false,
  status: "",
};

const fetchTermsOfUse = createAsyncThunk("fetch/termsOfUse", async () => {
  try {
    const result = await axios.get(`${process.env.REACT_APP_CMS_URL}/terms-of-uses`, {
      commonHeaderNotRequired: true,
    });
    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const termsOfUseSlice = createSlice({
  name: "termsOfUse",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchTermsOfUse.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTermsOfUse.fulfilled, (state, action) => {
      state.loading = false;
      state.termsData = action?.payload?.data;
      state.error = "";
    });
    builder.addCase(fetchTermsOfUse.rejected, (state, action) => {
      state.loading = false;
      state.termsData = [];
      state.error = action.error.message;
    });
  },
});

export default termsOfUseSlice.reducer;
export { fetchTermsOfUse }; 